import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { NgModule } from '@angular/core';
import { EnrollEmailDuplicateModule } from '../enrollEmailDuplicate/enroll-email-duplicate.module';
import { EqualValidatorModule } from '../equalValidator/equal-validator.module';
import { PhotoListComponent } from './photo-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    EnrollEmailDuplicateModule,
    EqualValidatorModule,
    MatDatepickerModule,
    MatListModule,
    MatIconModule,
    MatCheckboxModule,
    MatRadioModule,
    ImageCropperModule,
    DragDropModule,
    ImageCropperModule,
  ],
  declarations: [PhotoListComponent],
  exports: [PhotoListComponent],
})
export class PhotoListModule {}
